import { ApiConsumes, ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req, UseInterceptors, UploadedFile} from '@nestjs/common';
import {ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { SpecSheetService } from './spec-sheet.service';
import { AllSpecSheetResponseModel, SpecSheetResponseModel } from '@gtpl/shared-models/masters';
import { SpecSheetDto } from './dto/spec-sheet.dto';
import { SpecSheetRequest } from './dto/specsheet-request';
import { FileInterceptor } from '@nestjs/platform-express';
import { diskStorage } from 'multer';
import { extname } from 'path';
import { SpecSheetFileUploadDto } from './dto/spec-sheet-fileupload';
import { FileUploadResponse } from '@gtpl/shared-models/logistics';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';



@ApiTags('specsheet')
@Controller('specsheet') 

export class SpecSheetController{

    constructor(
        private specsheetservice: SpecSheetService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
  
      ){}
      @Post('/createSpecSheet')
      async createSpecSheet(@Body() specsheetgDto:SpecSheetDto,isUpdate:boolean=false): Promise<SpecSheetResponseModel> {
        try {
          console.log("specsheetgDto *****************************"+specsheetgDto);
            return await this.specsheetservice.createSpecSheet(specsheetgDto, false);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(SpecSheetResponseModel, error);
          }
        }

        @Post('/updateSpecSheet')
        async updateSpecSheet(@Body() SpecsheetDto: SpecSheetDto,@Req() request:Request): Promise<SpecSheetResponseModel> {
          try {
            console.log('update downtimetracking'+SpecsheetDto);
            console.log(request);
            return await this.specsheetservice.createSpecSheet(SpecsheetDto, true);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(SpecSheetResponseModel, error);
          }
        }
        @Post('/getAllSpecSheetDetails')
        // @UseGuards(AuthGuard('jwt'))
        async getAllSpecSheetDetails(@Body() req?:UserRequestDto): Promise<AllSpecSheetResponseModel> {
          try {
            return await this.specsheetservice.getAllSpecSheetDetails(req);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(AllSpecSheetResponseModel, error);
          }
        }

        @Post('/activateOrDeactivateSpecSheetDetails')
        async activateOrDeactivateSpecSheetDetails(@Body() req: SpecSheetRequest): Promise<SpecSheetResponseModel> {
            try {
                return await this.specsheetservice.activateOrDeactivateSpecSheetDetails(req);
            } catch (err) {
                return this.applicationExceptionHandler.returnException(SpecSheetResponseModel, err);
            }
        }
        @Post('/getAllActiveSpecSheetDetails')
        async getAllActiveSpecSheetDetails(@Req() request: SpecSheetRequest): Promise<AllSpecSheetResponseModel> {
            try {
                return await this.specsheetservice.getAllActiveSpecSheetDetails();
            } catch (error) {
                return this.applicationExceptionHandler.returnException(AllSpecSheetResponseModel, error)
            }
        }

       
    @Post('/getActiveSpecSheetById')
    async getActiveSpecSheetById(@Body() req: SpecSheetRequest): Promise<SpecSheetResponseModel> {
        try {
            return await this.specsheetservice.getActiveSpecSheetById(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(SpecSheetResponseModel, err);
        }
    }

    @Post('/specSheetFileUpload')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FileInterceptor('file', {
        limits: { files: 1 },
        storage: diskStorage({
        destination: './upload-files/spec-sheet-upload-files',
        filename: (req, file, callback) => {
            const name = file.originalname.split('.')[0];
            const fileExtName = extname(file.originalname);
            const randomName = Array(4)
            .fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16))
            .join('');
            callback(null, `${name}-${randomName}${fileExtName}`);
        },
        }),
        fileFilter: (req, file, callback) => {
        if (!file.originalname.match(/\.(csv|xlsx|xls|pdf|zip)$/)) {
            return callback(new Error('Only csv,xlsx,xls,pdf files are allowed!'), false);
        }
        callback(null, true);
        },
    }))
    async specSheetFileUpload(@UploadedFile() file, @Body() uploadData: SpecSheetFileUploadDto): Promise<FileUploadResponse> {
      console.log(file,'****')
        try {
            return await this.specsheetservice.updatePath(file.path,file.filename, uploadData.specSheetId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FileUploadResponse, error);
        }
    }
}